import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { fetchConToken } from 'helpers/fetch';
import { alertService } from '_services';
import Swal from 'sweetalert2';
import { useUIUtils } from 'hooks/useUIUtils';
import { avisarError, BotonesForma, Campo, SwitchSN, Tarjeta } from '../comun';

const inicial = {
    id: 0,
    nombre: '',
    tipo: 'E',
    moneda: 'MXN',
    autorizacion_Necesaria: 'N',
    cobrar_En_Exceso: 'S',
    dar_Cambio: 'S',
    contar_En_Corte: 'S',
    clave_Fiscal: '01',
    estatus: 'A'
};

const AddEdit = ({ history, match }) => {
    const { id } = match.params;
    const isAddMode = !id;
    const { handleSubmit } = useForm();
    const { changeGlobalTitle } = useUIUtils();
    const [model, setModel] = useState(inicial);

    function onSubmit() {
        return isAddMode ? guardar(model, 'POST', '.') : guardar(model, 'PUT', '..');
    }

    function guardar(data, method, destino) {
        return fetchConToken('pv/PvFormasCobros', data, method)
            .then((response) => {
                if (avisarError(response)) return false;
                Swal.fire('Exito', 'Guardado', 'success');
                history.push(destino);
            })
            .catch(alertService.error);
    }

    useEffect(() => {
        if (!isAddMode) {
            fetchConToken(`pv/PvFormasCobros?id=${id}`).then((response) => {
                if (!avisarError(response)) setModel(response);
            });
        }
    }, [id, isAddMode]);

    useEffect(() => {
        changeGlobalTitle(isAddMode ? 'Agregar forma de cobro' : 'Editar forma de cobro');
    }, [changeGlobalTitle, isAddMode]);

    const handleInputChange = ({ target }) => {
        setModel({ ...model, [target.name]: target.value });
    };

    const onChangeCheck = ({ target }) => {
        setModel({ ...model, [target.name]: target.checked ? 'S' : 'N' });
    };

    return (
        <div className='container-fluid'>
            <form onSubmit={handleSubmit(onSubmit)}>
                <div className='mb-3'>
                    <div className='row'>
                        <BotonesForma isAddMode={isAddMode} />
                    </div>
                </div>
                <div className='row'>
                    <div className='col-md-6'>
                        <Tarjeta titulo='Datos'>
                            <Campo label='Nombre'>
                                <input type='text' className='form-control' name='nombre' required value={model.nombre || ''} onChange={handleInputChange} />
                            </Campo>
                            <Campo label='Tipo'>
                                <select className='form-select' name='tipo' value={model.tipo || 'E'} onChange={handleInputChange}>
                                    <option value='E'>Efectivo</option>
                                    <option value='C'>Cheque</option>
                                    <option value='T'>Tarjeta</option>
                                    <option value='O'>Otro</option>
                                    <option value='R'>Credito</option>
                                </select>
                            </Campo>
                            <Campo label='Moneda'>
                                <input type='text' className='form-control' name='moneda' required value={model.moneda || ''} onChange={handleInputChange} />
                            </Campo>
                            <Campo label='Clave fiscal'>
                                <input type='text' className='form-control' name='clave_Fiscal' value={model.clave_Fiscal || ''} onChange={handleInputChange} />
                            </Campo>
                            <Campo label='Estatus'>
                                <select className='form-select' name='estatus' value={model.estatus || 'A'} onChange={handleInputChange}>
                                    <option value='A'>Activo</option>
                                    <option value='I'>Inactivo</option>
                                </select>
                            </Campo>
                        </Tarjeta>
                    </div>
                    <div className='col-md-6'>
                        <Tarjeta titulo='Comportamiento'>
                            <SwitchSN name='autorizacion_Necesaria' label='Requiere autorizacion' checked={model.autorizacion_Necesaria} onChange={onChangeCheck} />
                            <div className='espacio15px' />
                            <SwitchSN name='cobrar_En_Exceso' label='Permite cobrar en exceso' checked={model.cobrar_En_Exceso} onChange={onChangeCheck} />
                            <div className='espacio15px' />
                            <SwitchSN name='dar_Cambio' label='Permite dar cambio' checked={model.dar_Cambio} onChange={onChangeCheck} />
                            <div className='espacio15px' />
                            <SwitchSN name='contar_En_Corte' label='Contar en el corte de caja' checked={model.contar_En_Corte} onChange={onChangeCheck} />
                        </Tarjeta>
                    </div>
                </div>
            </form>
        </div>
    );
};

export { AddEdit };
